module.exports = __webpack_public_path__ + "media/svg/download-773fe45f.svg";